import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

// PrimeNG imports
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    CardModule,
    InputTextModule,
    ButtonModule,
    MessageModule
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent {
  // Define individual form control
  emailControl = new FormControl('', [Validators.required, Validators.email]);
  
  // Create form group using the individual control
  forgotPasswordForm = new FormGroup({
    email: this.emailControl
  });

  constructor(private translateService: TranslateService) {}

  onSubmit(): void {
    if (this.forgotPasswordForm.valid) {
      // TODO: Implement forgot password logic
      console.log('Forgot password form submitted:', this.forgotPasswordForm.value);
    } else {
      // Mark all fields as touched to show validation errors
      this.markFormGroupTouched();
    }
  }

  getEmailErrorMessage(): string {
    if (this.emailControl.errors?.['required']) {
      return this.translateService.instant('forgotPassword.errors.emailRequired');
    }
    if (this.emailControl.errors?.['email']) {
      return this.translateService.instant('forgotPassword.errors.emailInvalid');
    }
    return '';
  }

  private markFormGroupTouched(): void {
    this.emailControl.markAsTouched();
  }
}